import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=6d74a23c&scoped=true"
import script from "./CheckItem.vue?vue&type=script&lang=js"
export * from "./CheckItem.vue?vue&type=script&lang=js"
import style0 from "./CheckItem.vue?vue&type=style&index=0&id=6d74a23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74a23c",
  null
  
)

export default component.exports